import * as React from 'react'
import { ReactElement } from 'react'
import ReportForm from './ReportForm'
import { DocumentGenerationType } from '../../../../hooks/document/useDocumentGenerationHandler'

export default function FilesPerUserReportForm(): ReactElement {
    return <ReportForm title="Nieuwe dossiers" generationType={DocumentGenerationType.FileCreation} />
}
